import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

export type AuthProvider = 'default' | 'ardaco';

export function getAuthConfig(provider: AuthProvider = 'default'): AuthConfig {
  const oidcConfig = provider === 'ardaco' ? (environment as any).oidcArdaco : environment.oidc;

  return {
  // OIDC provider URL (Keycloak)
  issuer: oidcConfig.issuer,
  
  // URL kam sa ma pouzivatel vratit po prihlaseni - use from environment config
  redirectUri: oidcConfig.redirectUri || (window.location.origin + '/qsign-edesk-frontend/sso-redirect'),
  
  // URL kam sa ma pouzivatel vratit po odhlaseni
  postLogoutRedirectUri: window.location.origin + '/qsign-edesk-frontend',
  
  // Client ID aplikacie
  clientId: oidcConfig.clientId,
  
  // Rozsah opravneni - co chceme ziskat
  scope: oidcConfig.scope || 'openid profile email',
  
  // Typ odpovede - Authorization Code Flow s PKCE
  responseType: 'code',
  
  // PKCE code challenge method
  ...(oidcConfig.codeChallengeMethod && { codeChallengeMethod: oidcConfig.codeChallengeMethod }),
  
  // PKCE enabled for security (generates code_challenge and code_challenge_method)
  disablePKCE: false,
  
  // Cannot use refresh tokens without offline_access scope
  // Will use prompt=none re-authentication instead
  
  // Automaticke obnovenie tokenu na pozadi (disabled)
  // silentRefreshRedirectUri: window.location.origin + '/qsign-edesk-frontend/assets/silent-refresh.html',
  
  // Cas pred expiraciou tokenu, kedy sa ma zacat obnovovat (v sekundach)
  // silentRefreshTimeout: 10000,
  
  // Timeout pre silent refresh request  
  timeoutFactor: 0.75,
  
  // Session checks
  sessionChecksEnabled: true,
  
  // Validacia
  requireHttps: false,  // Pre playground server
  strictDiscoveryDocumentValidation: false,  // Pre Keycloak
  
  // Pouzit discovery endpoint pre automaticku konfiguraciu
  oidc: true,
  
  // Use query parameters instead of hash fragments for OAuth response
  responseMode: 'query',
  
  // Validacia ID tokenu - relaxed pre playground
  skipIssuerCheck: false,
  disableAtHashCheck: true,  // Disable at_hash check pre public client
  
  // Custom parameter pre PKCE a silent authentication
  customQueryParams: {
    // Parameters will be added dynamically via initCodeFlow
    // e.g., { prompt: 'none' } for silent login
  },
  
  // Automaticke zobrazenie chybovych hlaseni (disabled to reduce console noise)
  showDebugInformation: false,
  
  // Cas po ktorom vyprsi session check (v ms) - increased to reduce console noise
  sessionCheckIntervall: 30000, // 30 seconds instead of 3 seconds
  
  // Ak potrebujete pridat custom headers
  customTokenParameters: []
  };
}

// Default auth config (backwards compatibility)
export const authConfig: AuthConfig = getAuthConfig('default');
